import { Subject } from 'rxjs';

export class ScreenMenu {
    id: string;
    caption: string;
    type: string;
    iconName: string;
    items: ScreenMenu[];
    tid: string;

    constructor(id: string, caption: string, type: string, iconName: string, items: ScreenMenu[], tid: string) {
        this.id = id;
        this.caption = caption;
        this.type = type;
        this.iconName = iconName;
        this.items = items;
        this.tid = tid;
    }
}

export class ScreenConfig {
    id: string;
    screenType: string;
    feedbackSubject$: Subject<any>;

    constructor() {
        this.feedbackSubject$ = new Subject<any>();
    }
}

export enum HomeScreenType {
    HomeScreen = 'homeScreen'
}

export enum HomeScreenTabType {
    share = 'share',
    self = 'self'
}

export class HomeScreenTab {
    id: string;
    name: string;
    screenId: string;
    screenType: string;
    type: HomeScreenTabType;
    editable: boolean;

    constructor(id, name, screenId, screenType, type, editable) {
        this.id = id;
        this.name = name;
        this.screenId = screenId;
        this.screenType = screenType;
        this.type = type;
        this.editable = editable;
    }
}

export class HomeScreenConfig {
    id: string;
    name: string;
    description: string;
    type: HomeScreenType;
    isPublic: boolean;
    tabs: HomeScreenTab[];
    accessList: Array<string>;

    constructor() {
        this.id = '';
        this.name = '';
        this.description = '';
        this.type = HomeScreenType.HomeScreen;
        this.isPublic = true;
    }
}
